import { render, staticRenderFns } from "./GalleryCreateTranslation.vue?vue&type=template&id=76302045&"
import script from "./GalleryCreateTranslation.vue?vue&type=script&lang=js&"
export * from "./GalleryCreateTranslation.vue?vue&type=script&lang=js&"
import style0 from "./GalleryCreateTranslation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports